// Config-driven portal module registry. Sidebar + routes are generated from this.
export const MODULES = [
  { slug: "overview", label: "Overview", icon: "Gauge", group: "main" },
  { slug: "cloud-accounts", label: "Cloud Accounts", icon: "Cloud", group: "cloud", resource: "cloud-accounts" },
  { slug: "projects", label: "Projects", icon: "Workflow", group: "cloud", resource: "projects" },
  { slug: "managed-services", label: "Managed Services", icon: "Settings", group: "cloud", resource: "managed-services" },
  { slug: "cloud-health", label: "Cloud Health", icon: "Gauge", group: "cloud", resource: "cloud-health" },
  { slug: "cost-optimization", label: "Cost Optimization", icon: "PiggyBank", group: "cloud", resource: "cost-optimization" },
  { slug: "security", label: "Security", icon: "ShieldCheck", group: "cloud", resource: "security" },
  { slug: "backups", label: "Backups", icon: "HardDriveDownload", group: "cloud", resource: "backups" },
  { slug: "tickets", label: "Support Tickets", icon: "LifeBuoy", group: "support", resource: "tickets" },
  { slug: "service-requests", label: "Service Requests", icon: "GitBranch", group: "support", resource: "service-requests" },
  { slug: "notifications", label: "Notifications", icon: "Sparkles", group: "support", resource: "notifications" },
  { slug: "billing", label: "Billing", icon: "BarChart3", group: "finance", resource: "invoices" },
  { slug: "invoices", label: "Invoices", icon: "FileText", group: "finance", resource: "invoices" },
  { slug: "subscriptions", label: "Subscriptions", icon: "RefreshCw", group: "finance", resource: "subscriptions" },
  { slug: "licenses", label: "Licenses", icon: "KeyRound", group: "finance", resource: "licenses" },
  { slug: "contracts", label: "Contracts", icon: "FileText", group: "finance", resource: "contracts" },
  { slug: "documents", label: "Documents", icon: "Layers", group: "records", resource: "documents" },
  { slug: "reports", label: "Reports", icon: "LineChart", group: "records", resource: "reports" },
  { slug: "contacts", label: "Contacts", icon: "Users", group: "records", resource: "contacts" },
  { slug: "account-settings", label: "Account Settings", icon: "Settings", group: "records" },
];

export const GROUPS = [
  { key: "main", label: "" },
  { key: "cloud", label: "Cloud" },
  { key: "support", label: "Support" },
  { key: "finance", label: "Finance" },
  { key: "records", label: "Records" },
];

// Column definitions per resource for the generic table renderer.
export const COLUMNS = {
  "cloud-accounts": [
    { key: "provider", label: "Provider", strong: true },
    { key: "account_name", label: "Account" },
    { key: "region", label: "Region" },
    { key: "monthly_cost", label: "Monthly Cost", format: "currency" },
    { key: "status", label: "Status", format: "status" },
  ],
  projects: [
    { key: "name", label: "Project", strong: true },
    { key: "platform", label: "Platform" },
    { key: "owner", label: "Owner" },
    { key: "progress", label: "Progress", format: "progress" },
    { key: "due", label: "Due", format: "date" },
    { key: "status", label: "Status", format: "status" },
  ],
  "managed-services": [
    { key: "service", label: "Service", strong: true },
    { key: "tier", label: "Tier" },
    { key: "sla", label: "SLA" },
    { key: "coverage", label: "Coverage" },
    { key: "status", label: "Status", format: "status" },
  ],
  "cloud-health": [
    { key: "name", label: "Platform", strong: true },
    { key: "uptime", label: "Uptime", format: "percent" },
    { key: "incidents", label: "Incidents" },
    { key: "status", label: "Status", format: "status" },
  ],
  "cost-optimization": [
    { key: "recommendation", label: "Recommendation", strong: true },
    { key: "platform", label: "Platform" },
    { key: "monthly_savings", label: "Monthly Savings", format: "currency" },
    { key: "effort", label: "Effort", format: "badge" },
  ],
  security: [
    { key: "control", label: "Control", strong: true },
    { key: "platform", label: "Platform" },
    { key: "severity", label: "Severity", format: "badge" },
    { key: "status", label: "Status", format: "status" },
  ],
  backups: [
    { key: "resource", label: "Resource", strong: true },
    { key: "last_backup", label: "Last Backup", format: "date" },
    { key: "retention", label: "Retention" },
    { key: "size", label: "Size" },
    { key: "status", label: "Status", format: "status" },
  ],
  tickets: [
    { key: "ref", label: "Ref", strong: true },
    { key: "subject", label: "Subject" },
    { key: "priority", label: "Priority", format: "badge" },
    { key: "created_at", label: "Created", format: "date" },
    { key: "status", label: "Status", format: "status" },
  ],
  "service-requests": [
    { key: "ref", label: "Ref", strong: true },
    { key: "title", label: "Title" },
    { key: "platform", label: "Platform" },
    { key: "created_at", label: "Created", format: "date" },
    { key: "status", label: "Status", format: "status" },
  ],
  invoices: [
    { key: "number", label: "Invoice", strong: true },
    { key: "period", label: "Period" },
    { key: "amount", label: "Amount", format: "currency" },
    { key: "due_date", label: "Due", format: "date" },
    { key: "status", label: "Status", format: "status" },
  ],
  subscriptions: [
    { key: "name", label: "Subscription", strong: true },
    { key: "billing_cycle", label: "Cycle" },
    { key: "amount", label: "Amount", format: "currency" },
    { key: "next_billing", label: "Next Billing", format: "date" },
    { key: "status", label: "Status", format: "status" },
  ],
  licenses: [
    { key: "product", label: "Product", strong: true },
    { key: "vendor", label: "Vendor" },
    { key: "assigned", label: "Assigned" },
    { key: "total", label: "Total" },
    { key: "renewal", label: "Renewal", format: "date" },
  ],
  contracts: [
    { key: "name", label: "Contract", strong: true },
    { key: "start", label: "Start", format: "date" },
    { key: "end", label: "End", format: "date" },
    { key: "value", label: "Value", format: "currency" },
    { key: "status", label: "Status", format: "status" },
  ],
  documents: [
    { key: "name", label: "Document", strong: true },
    { key: "type", label: "Type" },
    { key: "size", label: "Size" },
    { key: "updated", label: "Updated", format: "date" },
  ],
  reports: [
    { key: "name", label: "Report", strong: true },
    { key: "type", label: "Type" },
    { key: "generated", label: "Generated", format: "date" },
  ],
  contacts: [
    { key: "name", label: "Name", strong: true },
    { key: "role", label: "Role" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone" },
  ],
};

export const ROLE_LABELS = {
  client_owner: "Client Owner",
  client_admin: "Client Administrator",
  billing_admin: "Billing Administrator",
  technical_admin: "Technical Administrator",
  security_admin: "Security Administrator",
  standard_user: "Standard User",
  read_only: "Read Only",
};
